import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import TierBadge from './TierBadge';

const FEATURES = [
  {
    icon: '🔐',
    title: 'No Bank Linking',
    body: 'Unlike other wealth management apps, moneyplant never asks for your bank credentials. You enter your numbers manually. Your data stays yours.',
  },
  {
    icon: '📊',
    title: 'No Spreadsheet Hassle',
    body: 'No formulas, no chart setup, no spreadsheet version management. Net worth trends, asset breakdowns, liability tracking, and FIRE projections come built in.',
  },
  {
    icon: '🌍',
    title: 'Global & Crypto Ready',
    body: 'Track assets across 100+ fiat currencies and 800+ cryptocurrencies. Everything converts into one view automatically.',
  },
];

const NAV_CARDS = [
  { icon: '📈', title: 'Net Worth',    body: 'Track your wealth over time.',       to: '/networth' },
  { icon: '🏦', title: 'Assets',       body: 'Manage your asset portfolio.',        to: '/asset'    },
  { icon: '💳', title: 'Liabilities',  body: 'Stay on top of what you owe.',        to: '/liability' },
  { icon: '🔥', title: 'FIRE',         body: 'Plan your path to retirement.',       to: '/fire'     },
];

const Home = (props) => {
  if (props.user) {
    return (
      <Container className="py-4">
        <Row className="mb-4">
          <Col>
            <h3 className="mb-1">Welcome Back, {props.user.attributes.given_name}!</h3>
            {props.userInfo && <TierBadge tier={props.userInfo.tier} />}
          </Col>
        </Row>
        <Row className="g-3">
          {NAV_CARDS.map(card => (
            <Col xs={12} sm={6} key={card.to}>
              <Card as={Link} to={card.to} className="h-100 text-decoration-none home-nav-card bg-light border-0">
                <Card.Body className="d-flex flex-column">
                  <div className="mb-2" style={{ fontSize: '1.8rem' }}>{card.icon}</div>
                  <Card.Title>{card.title}</Card.Title>
                  <Card.Text className="text-muted flex-grow-1">{card.body}</Card.Text>
                  <span className="text-primary fw-semibold">View →</span>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      <Row className="py-5 text-center">
        <Col>
          <img alt="moneyplant logo" src="/favicon.ico" width="150px" height="150px" className="mb-1" />
          <h1 className="brand-text mb-2" style={{ marginTop: '-8px' }}>moneyplant - the personal net worth tracker</h1>
          <h5 className="text-muted mb-4">Smarter than a spreadsheet. More private than other wealth management apps.</h5>
          <p className="lead mb-4">
            moneyplant is a personal net worth tracker that sits between spreadsheets and other wealth management apps.<br />
            No bank credentials. No formulas. No chart management.<br />
            Just enter your assets and liabilities and your financial picture builds itself.
          </p>
          <Button variant="primary" size="lg" onClick={props.onGetStarted}>
            Get Started
          </Button>
        </Col>
      </Row>
      <Row className="g-3 pb-5">
        {FEATURES.map(f => (
          <Col xs={12} md={4} key={f.title}>
            <Card className="h-100 text-center border-0 bg-light">
              <Card.Body>
                <div className="mb-2" style={{ fontSize: '2rem' }}>{f.icon}</div>
                <Card.Title>{f.title}</Card.Title>
                <Card.Text className="text-muted">{f.body}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <Row className="pb-5">
        <Col>
          <p className="text-muted text-center" style={{ fontSize: '0.85rem', maxWidth: '640px', margin: '0 auto' }}>
            moneyplant helps you track all your assets (savings accounts, investments, real estate, cryptocurrencies,
            and retirement accounts) alongside liabilities (loans and credit cards), to give you a clear net worth
            picture over time. Whether you are building toward financial independence, planning for retirement, or simply
            want to know where you stand, moneyplant gives you the tools without the complexity of a spreadsheet or the
            privacy risk of linking your bank accounts.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Home;
